import { Grid } from '@mui/material'
import React from 'react'
import Heading from './Heading'
import FullName from './FullName'
import Email from './Email'
import ShortText from './ShortText'
import LongText from './LongText'
import FileUpload from './FileUpload'

const DesignApprovalForm = () => {
    return (
        <Grid p={{ xs: '40px 13px', md: '40px 52px' }} bgcolor={'white'} borderRadius={'20px'} width={'100%'} maxWidth={'700px'} boxShadow={'0 4px 4px rgba(87,100,126,.21)'} m={{ xs: '72px 0px', md: '72px 42px' }}>
            <Heading header={'تأیید طراحی'} subHeader={''} />
            <Grid className='states' display={'flex'} flexDirection={'column'} alignItems={'flex-start'} justifyContent={'flex-start'}>
                <FullName header={'نام مشتری'}/>
                <Email header={'ایمیل مشتری'}/>
                <ShortText header={'پروژه'}/>
                <LongText header={'شرح پروژه'}/>
                <FileUpload header={'پیوست‌ها'}/>
                <FullName header={'نام طراح'}/>
                <Email header={'ایمیل طراح'}/>
            </Grid>
        </Grid>
    )
}

export default DesignApprovalForm
